"use client";
import styled from "styled-components";
export const StyledWrapper = styled.div`
  ul {
    list-style: disc;
  }

  h1,
  h2,
  h6,
  h3,
  h4,
  h5,
  h6 {
    color: #333333;
  }
  strong {
    color: #333333;
  }
  p,
  li,
  td {
    color: #535353; /* Replace with your color */
  }
  ol,
  ul {
    padding-left: 1.5rem;
    list-style-type: disc;
    color: #535353;
    font-size: 20px !important;
  }

  table {
    border: 1px solid black;
    margin-top: 26px;
    margin-bottom: 26px;
    color: #535353;
    width: 100% !important;
    min-width: 200px;
    display: block;
    max-width: 100%; /* fallback for desktop */
    overflow-x: auto;
    border-collapse: collapse; /* Prevents double borders */
  }

  td {
    padding: 15px;
    color: #535353;
    border: 1px solid black;
    font-size: 20px !important;
  }

  th{
    border: 1px solid black;
  }
  .table-container {
    width: 100%;
    overflow-x: auto;
  }
  a {
    /* Default text color */
    /* Default font weight */
    text-decoration: underline; /* Underline the link */
    text-decoration-color: #1090d0; /* Set default underline color to blue */
    text-decoration-thickness: 2px; /* Set the thickness of the underline to 2px */
    text-underline-offset: 3px;
    text-underline-offset: 5px; /* Optional: adjust the distance of the underline from the text */
  }
  a:hover {
    text-decoration-color: #ef1649; /* Change underline color to pink on hover */
  }
  @media (max-width: 1300px) and (min-width: 500px) {
    td {
      font-size: 16px !important;
    }
  }
  @media (max-width: 449px) {
    td {
      font-size: 14px !important;
    }
  }

  blockquote {
    quotes: "“" "”";
    font-style: italic; /* Italicize the entire blockquote text */
    color: #535353;
    margin: 0 !important; /* Remove default margin */
    padding: 0 !important; /* Remove default padding */
    display: inline; /* Keep everything inline */
  }

  blockquote::before {
    content: open-quote;
    margin-bottom: 0; /* Remove spacing below */
    vertical-align: top; /* Align with the top of the text */
    line-height: 1; /* Match line height to text */
    font-size: inherit; /* Keep quote size consistent */
  }

  blockquote::after {
    content: close-quote;
  }

  blockquote p {
    margin: 0 !important; /* Remove margin from inside paragraphs */
    display: inline; /* Keep paragraph inline */
    font-style: italic; /* Italicize text inside paragraphs */
  }
`;
